import viridis from './resources/viridis'
// import cubehelix from './resources/cubehelix'
// import jet from './resources/jet'
// import hsv from './resources/hsv'

/**
 * @typedef {number[][]} ColorMapValues
 */

/**
 * @typedef {Object} ColorMapDesc
 * @property {string} name
 * @property {ColorMapValues} values
 */

/**
 * カラーマップデータ
 * @type {ColorMapDesc[]}
 */
export const colorMaps = [
	{ name: 'Viridis', values: viridis }
	// { name: 'Cubehelix', values: cubehelix },
	// { name: 'Jet', values: jet },
	// { name: 'HSV', values: hsv }
]
